import React from 'react';
import styled from 'styled-components';
import { IconWrap } from '../../icons/icon';
import { theme } from '../../theme/semanticTokens';
import { IconSize } from '../../types/icons/Icon.types';
import { IconType } from '../../types/icons/IconTypes.enum';
import { Typography } from '../../Typography';

type RemovableTagVariant =
  | 'primary'
  | 'blue'
  | 'yellow'
  | 'purple'
  | 'mintGreen'
  | 'pink'
  | 'chip';

export type RemovableTagProps = {
  variant?: RemovableTagVariant;
  text: string;
  onClose?: () => void;
};

const TagContainer = styled.div`
  display: inline-flex;
  align-items: center;
  //eight: 24px;
  border-radius: ${theme.dime.radius.s};
  border: 1px solid ${theme.dime.colors.border.static};

  &.blue {
    color: ${theme.dime.colors.text.decorative12};
    background-color: ${theme.dime.colors.fill.decorative11};
  }

  &.yellow {
    color: ${theme.dime.colors.text.decorative2};
    background-color: ${theme.dime.colors.fill.decorative1};
  }

  &.purple {
    color: ${theme.dime.colors.text.decorative4};
    background-color: ${theme.dime.colors.fill.decorative3};
  }
  &.pink {
    color: ${theme.dime.colors.text.decorative6};
    background-color: ${theme.dime.colors.fill.decorative5};
  }
  &.mintGreen {
    color: ${theme.dime.colors.text.primary};
    background-color: ${theme.dime.colors.fill.decorative7};
  }

  &.primary {
    color: ${theme.dime.colors.text.primary};
    background-color: ${theme.dime.colors.fill.secondary};
  }

  &.chip {
    font-family: ${theme.dime.fonts.families.roboto};
    border-radius: ${theme.dime.radius.l};
    background: ${theme.dime.colors.fill.brandSecondary};
    color: ${theme.dime.colors.text.brand};
    padding: ${theme.dime.spacing.s} ${theme.dime.spacing.l};
    font-size: ${theme.dime.fonts.sizes.sm};
    font-style: normal;
    font-weight: ${theme.dime.fonts.weights.regular};
    line-height: ${theme.dime.fonts.lineHeights.sm};
    gap: ${theme.dime.spacing.s};
    border: none;
  }
`;

const IconWarper = styled.div({
  display: 'flex',
  cursor: 'pointer'
});

const TextWrapper = styled(Typography)<{ textTransform?: string }>`
  padding: 1px 8px;
  display: flex;
  height: 22px;
  gap: ${theme.dime.spacing.s};
  align-items: center;
  justify-content: space-between;

  &.chip {
    padding: 0;
    font-size: ${theme.dime.fonts.sizes.sm};
    font-weight: ${theme.dime.fonts.weights.regular};
    line-height: ${theme.dime.fonts.lineHeights.sm};
    height: auto;
    justify-content: flex-start;
    color: ${theme.dime.colors.text.brand};

    ${IconWarper} {
      color: ${theme.dime.colors.icon.link};
    }
  }
`;

export const RemovableTag: React.FC<RemovableTagProps> = ({
  variant = 'primary',
  text,
  onClose
}) => {
  return (
    <TagContainer className={variant}>
      <TextWrapper className={variant} variant="body1">
        {text}
        {!!onClose && (
          <IconWarper>
            <IconWrap
              size={IconSize.Small}
              type={IconType.Close}
              onClick={onClose}
            />
          </IconWarper>
        )}
      </TextWrapper>
    </TagContainer>
  );
};
